import { Metric, ReportHandler } from 'web-vitals';
import { recordWebVital } from './utils/rum';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  const handler: ReportHandler = (metric: Metric) => {
    const metricWithDetails = metric as Metric & {
      rating?: string;
      navigationType?: string;
    };

    recordWebVital({
      name: metric.name,
      value: metric.value,
      delta: metric.delta,
      id: metric.id,
      rating: metricWithDetails.rating,
      navigationType: metricWithDetails.navigationType,
    });

    if (onPerfEntry && onPerfEntry instanceof Function) {
      onPerfEntry(metric);
    }
  };

  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
